<template>
  <div class="VideoPlayDialog">
      <el-dialog :title="title" :visible.sync="active" :before-close="closeVideoPlayPopu">
          <video-player  class="video-player vjs-custom-skin"
                            ref="videoPlayer"
                            :playsinline="true"
                            :options="playerOptions">
            </video-player>
      </el-dialog>
  </div>
  <!-- end 视频播放弹窗 -->
</template>

<script>
import {videoPlayer} from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
export default {
  name: 'VideoPlayDialog',
  data () {
    return {
        title: '视频播放',
        active: false,
        playerOptions : {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大    小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                  {
                    src: '',  // 路径
                    type: 'video/mp4'  // 类型
                },
                {
                  type: 'application/x-mpegURL', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                  src:
                    'https://cdn.letv-cdn.com/2018/12/05/JOCeEEUuoteFrjCg/playlist.m3u8' // url地址，从别的博主那看来的地址，亲测可用
                  }
                //  , {
                //     src: '',
                //     type: 'video/webm'
                // }
                ],
                poster: "", //你的封面地址
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true  //全屏按钮
                }
            },
    }
  },
  mounted () {},
  methods: {
      playVideo(src) {  // 播放视频
        this.playerOptions.sources[0].src = src
        // console.log(src)
      },
      startVideoPlayPopu(src, coveratturl) {    // 开启视频播放弹窗
        this.active  = true
        this.playVideo(src)
        this.playerOptions.poster = coveratturl // 视频封面
      },
      closeVideoPlayPopu() {    // 关闭视频播放弹窗
        this.active  = false
        // 暂停视频播放
        this.playerOptions.sources[0].src = ""
      }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      videoPlayer
  }
}
</script>

<style lang="scss" type="text/scss">
.VideoPlayDialog {
    .video-js .vjs-big-play-button {
        margin: auto;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;     
    }
}
</style>